<template>
<div class="card" @click="routeTo">
  <div class="contents">
    <div class="material-icon icon">{{ icon }}</div>
    <div class="text">{{ short }}</div>
    <div class="description"><slot></slot></div>
  </div>
</div>
</template>

<script>
export default {
  name: "MenuCard",
  props: ["icon", "route", "short"],
  methods: {
    routeTo() {
      this.$router.push({name: this.route});
    }
  }
}
</script>

<style scoped>
.card{
  display: flex;
  width: 250px;
  min-height: 150px;
  cursor: pointer;
  border-radius: 30px;
  margin: 10px;
  padding: 10px;
  align-items: center;
  border: 1px solid rgba(128, 128, 128, 0.51);
  box-shadow: 2px 2px 10px 0 rgba(128, 128, 128, 0.38);

}
.text {
  width: 100%;
  font-size: 25px;
  font-weight: bolder;
}
.description {
  width: 100%;
  font-size: 14px;
}
.icon {
  width: 100%;
  font-size: 80px;
}
.contents {
  width: 100%;
  min-height: 250px;
  display: flex;
  flex-wrap: wrap;
  align-content: baseline;
}

</style>